import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { DatasetLinkedOutlined } from "@mui/icons-material";
import { InfoDataChip } from "../../../common/widget-header/source-and-name/InfoDataChip";
import { DateInfoChip } from "../../../../adding-widget/widget-create/widget-setups/common/DateInfoChip";
import { coverageGroupByTitleByGrouping } from "../../../../adding-widget/widget-create/widget-setups/coverage/utils/constants/constants";
import { commitmentTypeTitleByType } from "../../../../adding-widget/widget-create/widget-setups/commitment-utilization/utils/constants/constants";
import { SourceDataChip } from "../../../common/widget-header/source-and-name/SourceDataChip";
import { organisationQuarterStartMonthSelector } from "@/store/common/selectors/org-current-settings/organisationQuarterStartMonthSelector";
import { useAppSelector } from "@/store/hooks";
import {
  CommitmentCloudProvider,
  CommitmentUtilizationType,
  CoverageGrouping,
  Dates,
} from "@/services/cloudchipr.api";

export interface CoverageWidgetHeaderInfoProps {
  providerOrganisationId?: string;
  commitmentType?: CommitmentUtilizationType;
  grouping?: CoverageGrouping;
  dates?: Dates;
  provider?: CommitmentCloudProvider;
}

export const CoverageWidgetHeaderInfo: FC<CoverageWidgetHeaderInfoProps> = ({
  commitmentType,
  providerOrganisationId,
  dates,
  grouping,
  provider,
}) => {
  const quarterStartMonth = useAppSelector(
    organisationQuarterStartMonthSelector,
  );
  const active = commitmentType === "all" ? "overview" : commitmentType;

  return (
    <Stack direction="row" gap={1} alignItems="center" overflow="auto">
      {(providerOrganisationId || provider) && (
        <SourceDataChip
          url={`/commitments/${providerOrganisationId ?? provider}?active=${active}`}
          title={
            commitmentType === "all"
              ? "Commitments"
              : `${commitmentTypeTitleByType.get(commitmentType ?? "reservation")}s`
          }
          icon={DatasetLinkedOutlined}
          openIn="Commitments"
        />
      )}

      {grouping && (
        <InfoDataChip>
          Group By:{" "}
          <Typography
            component="span"
            variant="inherit"
            fontWeight="medium"
            color="text.primary"
          >
            {coverageGroupByTitleByGrouping.get(grouping)}
          </Typography>
        </InfoDataChip>
      )}

      <DateInfoChip {...dates} quarterStartMonth={quarterStartMonth} />
    </Stack>
  );
};
